export const EVENTS = {
  SCREEN_SHARE: 'screen_share',
  OPEN_SETTINGS: 'open_settings',
  TOGGLE_VIRTUAL_BACKGROUND: 'toggle_virtual_background',
  CHANGE_VIRTUAL_BACKGROUND: 'change_virtual_background',
  ADD_RATING: 'add_rating',
  JOIN_CHANNEL: 'join_channel',
  TOGGLE_DEVICE: 'toggle_device',
  REQUEST_DEVICE: 'request_device',
  DEVICE_OUTCOME: 'device_outcome',
  CHANGE_DEVICE: 'change_device',
  FOCUS_STREAM: 'focus_stream',
  SHOW_MODAL: 'show_modal',
  REFRESH_CUSTOMER_VIDEO: 'refresh_customer_video',
};

// Not using "track()" like in other projects, because we have too many "track" device
// variables and it might be confusing for devs
export function gtag(eventName: string, data?: object) {
  window.dataLayer?.push({ ...data, event: eventName });

  if (process.env.NODE_ENV !== 'production') {
    console.info(
      `%cEvent %c ${eventName}`,
      'color: #FF8118; font-size:24px;',
      'color: #00B9F3; font-size:24px;',
      data,
    );
  }
}
